import { ConfirmDialog, toast } from '@core/components';
import { useConfirmDialog } from '@core/hooks/useConfirmDialog';
import { type Order, moveOrderToProduction } from '../../api/order';
import { useJobOrderPrint } from './useJobOrderPrint';

interface MoveToProductionDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order | null;
  onSuccess?: () => void;
}

const MoveToProductionDialog = ({
  open,
  onClose,
  order,
  onSuccess,
}: MoveToProductionDialogProps) => {
  const {
    isPrintAvailable,
    printQueuedJobOrders,
    printView,
    attestationDialog,
  } = useJobOrderPrint();

  const { loading, confirm, cancel } = useConfirmDialog({
    open,
    onClose,
    onConfirm: async () => {
      if (!order) return;
      await moveOrderToProduction(order.id);
    },
    onSuccess: () => {
      if (isPrintAvailable) {
        toast.action(
          'Order moved to production and all items are queued for printing',
          {
            label: 'Print now',
            onClick: () => printQueuedJobOrders(),
          }
        );
      } else {
        toast.success(
          'Order moved to production and all items are queued for printing'
        );
      }
      onSuccess?.();
    },
    errorMessage: 'Failed to move order to production',
  });

  return (
    <>
      <ConfirmDialog
        open={open}
        title="Move order to production"
        content="The order will be moved to production and its job orders will be queued for printing. Continue?"
        confirmText="Move"
        cancelText="Cancel"
        onConfirm={confirm}
        onCancel={cancel}
        loading={loading}
      />
      {printView}
      {attestationDialog}
    </>
  );
};

export default MoveToProductionDialog;
